import React from 'react';
import { useTypewriter } from '@/hooks/useTypewriter';
import { cn } from '@/lib/utils';

interface TypewriterMessageProps {
  text: string;
  speed?: number;
  delay?: number;
  onComplete?: () => void;
  onUpdate?: () => void;
  className?: string;
  showCursor?: boolean;
}

export const TypewriterMessage: React.FC<TypewriterMessageProps> = ({
  text,
  speed = 25,
  delay = 0,
  onComplete,
  onUpdate,
  className,
  showCursor = true
}) => {
  const { displayedText, isTyping, isComplete, skipToEnd } = useTypewriter({
    text,
    speed,
    delay,
    onComplete,
    onUpdate
  });

  return (
    <span 
      className={cn("inline", className)}
      onClick={!isComplete ? skipToEnd : undefined}
    >
      {displayedText}
      {showCursor && isTyping && (
        <span className="animate-pulse ml-0.5">|</span>
      )}
    </span>
  );
};
